export enum ErrorMessageEnum {
  invalid_questions_count = 'invalid questions count.',
  invalid_point_value_count_msg = 'Not enough questions with required point values',
  failed_to_create_game = 'Failed to create a game',
}
